import React, { Component } from 'react';
import { Table, Row, Button, Spin, } from 'antd';
import TableText from "@/bp-views/table/TableText";
import { inject, observer } from "mobx-react";
import FileSaver from "file-saver";
import "./index.scss";
import { toJS } from 'mobx';


const TOTALINDEX = [];
const TITLE = "1.2.1 分区域酒店会议场地出租率";

@inject('store')
@observer
class index extends Component {

    state = {
        print: false
    }

    onExpoetExcel = () => {
        const name = `${TITLE}`;
        const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${name}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { area, date, dataAll, loading, } = this.props.store.effectOcc;
        const columns = [{
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 300,
            render: (text, record, index) => {


                const props = { text, index, type: 'text', name: "name", totalIndex: TOTALINDEX };

                return <TableText data={{
                    ...props
                }} />
            }
        }, {
            title: <div>Space Occupancy<br />东南华南会议场地出租率</div>,
            dataIndex: 'space1',
            key: 'space1',
            align: "center",
            width: 200,
            render: (text, record, index) => {

                const props = {
                    text, index, type: 'percent', name: "space1", totalIndex: TOTALINDEX,
                    compared: {
                        title: ['Space Occupancy<br />东南华南会议场地出租率'],
                        record,
                        sqlName: "effect_area"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        },
        {
            title: <div>Space Occupancy<br />华北华中会议场地出租率</div>,
            dataIndex: 'space2',
            key: 'space2',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "space2", totalIndex: TOTALINDEX,
                    compared: {
                        title: ['Space Occupancy<br />华北华中会议场地出租率'],
                        record,
                        sqlName: "effect_area"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        },
        {
            title: <div>Space Occupancy<br />江浙沪皖会议场地出租率</div>,
            dataIndex: 'space3',
            key: 'space3',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "space3", totalIndex: TOTALINDEX,
                    compared: {
                        title: ['Space Occupancy<br />江浙沪皖会议场地出租率'],
                        record,
                        sqlName: "effect_area"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        },
        {
            title: <div>Space Occupancy<br />西南会议场地出租率</div>,
            dataIndex: 'space4',
            key: 'space4',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "space4", totalIndex: TOTALINDEX,
                    compared: {
                        title: ['Space Occupancy<br />西南会议场地出租率'],
                        record,
                        sqlName: "effect_area"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }];

        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 style-center">


                    <Row className="title" id="table6_2"  >
                        <Row> {TITLE}</Row>

                        <Table
                            columns={columns}
                            dataSource={toJS(area)}
                            size="middle"
                            bordered
                            id="table"
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                            scroll={this.state.print ? {} : { y: 500 }}
                        />
                    </Row>
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.onExpoetExcel();
                                });
                            }}
                        >导出Excel</Button>
                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;





// WEBPACK FOOTER //
// ./src/components/table/effect/1.2/Area.js